export default "__VITE_ASSET__51oiWnPN__"